var $ = require('jquery');
import tippy from 'tippy.js';
import {roundArrow} from 'tippy.js';
import {gsap} from 'gsap';
import { TextPlugin } from "gsap/TextPlugin";

gsap.registerPlugin(TextPlugin);


$('.calculator').each(function() {
    var _this = $(this);

    var input = _this.find('.calculator__block-slider');
    var depositBlock = _this.find('.calculator__block--deposit');
    var depositStatement = depositBlock.find('.calculator__block-statement');
    
    _this.find('.calculator__block-slider-val-toggle').on('click', function() {
        depositBlock.toggleClass('input-active');
        var currentInput;

        if ( depositBlock.hasClass('input-active') ) {
            depositStatement.hide();
            currentInput = _this.find('input[type="number"]');
        } else {
            currentInput = _this.find('input[type="range"]');
            updateStatementValue(currentInput, depositBlock);
            depositStatement.show();
        }
        
        if ( _this.find('input[type="number"]').val() == _this.find('input[type="range"]').val() ) return;
        calculate(currentInput.val(), _this);
    })

    
    input.find('input[type="range"]').on('input', function() {
        _this.find('.calculator__block-slider').attr('data-value', $(this).val());
        input.find('input[type="number"]').val($(this).val());
        updateStatementValue($(this), depositBlock);
        calculate($(this).val(), _this);
    })
    
    input.find('input[type="number"]').on('change', function() {
        _this.find('.calculator__block-slider').attr('data-value', parseFloat($(this).val()));
        input.find('input[type="range"]').val($(this).val());
        updateStatementValue($(this), depositBlock);
        calculate($(this).val(), _this);
    })



    animateIcons($(this).find('.calculator__icons'));
})

$('.calculator__block-slider input[type="number"').on('focus', function (e) {
    $(this).on('wheel.disableScroll', function (e) {
        e.preventDefault()
    })
})
$('.calculator__block-slider input[type="number"').on('blur', function (e) {
    $(this).off('wheel.disableScroll')
})

function updateStatementValue(el, block) {
    var currentVal = el.val();
    var formattedVal = new Intl.NumberFormat( 'en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
    } );
    block.find('.calculator__block-value').text(formattedVal.format(currentVal));
}

function calculate(currentVal, parent) {
    if ( currentVal > 100000 ) {
        if ( parent.find('.calculator__block--deposit').hasClass('input-active') ) {
            if ( currentVal > 999999999 ) {
                alert( 'Please enter a number that doesn\'t exceed $999,999,999' );
                return;
            } 
        }
    };
    let carbonVal = ( ( currentVal/1000000 ) * 99 );
    let gasVal = ( carbonVal / ( 8.887 * ( Math.pow( 10, -3 ) ) )).toFixed(0); 

    // parent.find('.calculator__block--carbon .calculator__block-value').text(numberWithCommas(carbonVal.toFixed(1)));
    // parent.find('.calculator__block--gas .calculator__block-value').text(numberWithCommas(gasVal));
    animateNumbers( 
        parent.find('.calculator__block--carbon .calculator__block-value'), 
        parseInt(parent.find('.calculator__block--carbon .calculator__block-value').text()), 
        carbonVal.toFixed(1)
    );
    animateNumbers( 
        parent.find('.calculator__block--gas .calculator__block-value'), 
        parseInt(parent.find('.calculator__block--gas .calculator__block-value').text()),
        gasVal
    );
    // parent.find('.calculator__block--carbon .calculator__block-value').text(numberWithCommas(carbonVal.toFixed(1)));
    // parent.find('.calculator__block--gas .calculator__block-value').text(numberWithCommas(gasVal));
}

tippy('.calculator__block-tooltip-icon', {
    content: (reference) => $(reference).parent().find('.calculator__block-tooltip-content').html(),
    allowHTML: true,
    arrow: roundArrow,
    interactive: true,
    hideOnClick: false,
})

$('.calculator__icons').flickity({
    contain: true,
    prevNextButtons: false,
    cellAlign: 'left',
    watchCSS: true,
})

$('.calculator__icon-image').each(function () {
    var _thisTooltipContentElement = $(this).parent().find('.calculator__icon-tooltip');
    var _thisTooltipExit = $(this).parent().find('.calculator__icon-tooltip-exit');

    // check to make sure we have tooltip content before creating the tooltip
    if (_thisTooltipContentElement.length) {
        var tooltip = tippy(this, {
            content: _thisTooltipContentElement.html(),
            allowHTML: true,
            arrow: roundArrow,
            interactive: true,
            // trigger: 'click',
            duration: 0,
            hideOnClick: false, 
        });

        $('body').on('click', '.calculator__icon-tooltip-exit', function(e) {
            e.stopPropagation();
            tooltip.hide();
            if ($('.tooltip-modal').length) {
                $('.tooltip-modal').remove();
            }
        });

        if ( $(window).width() < 991 ) {
            tooltip.disable();
        } else {
            tooltip.enable();
        }
    }
});

$(window).on('resize', function() {
    if ( $(window).width() > 991 ) {
        $('.calculator__icon-image').off('click')
    } else {
        $('.calculator__icon-image').on('click', function() {
            console.log('here');
            iconModal($(this));
        })
    }
})

function iconModal(el) {
    var content = el.parent().find('.calculator__icon-tooltip').html();


    var markup = `<div class="tooltip-modal">
        <div class="tooltip-modal__content-container">
            ${content}
        </div>
    </div>`;

    $('body').append(markup);
}

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function animateNumbers(el, currentVal, newVal) {
    var type = el.closest('.calculator__block').hasClass('calculator__block--gas') ? 'gas' : 'carbon';
    var value = { val: parseFloat(currentVal) };

    gsap.to(value, {
        val: newVal,
        duration: 1.5,
        onUpdate: function() {
            var final = type == 'carbon' ? (value.val).toFixed(1) : (value.val).toFixed(0);
            if ( value.val > 1000 ) {
                el.text(numberWithCommas(final));
            } else {
                el.text(final);
            }
        }
    })
}

function animateIcons(icons) {
    setInterval(function() {
        var randomNum = Math.floor(Math.random() * icons.children().length);
        var image = icons.children().eq(randomNum).find('.calculator__icon-image');
        var tl = gsap.timeline();

        if ( image.length ) {
            tl.to(image, {
                scale: 1.4,
                duration: 0.4,
            })
            .to(image, {
                scale: 1,
                duration: 1.5,
                clearProps: 'all'
            })
        }
    }, 3000);
}